var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "right-body", attrs: { id: "imageSaverVideoList" } },
    [
      _c("div", { staticClass: "imagesaver_content" }, [
        _c(
          "div",
          {
            staticClass: "video_task_clear",
            on: {
              click: function($event) {
                return _vm.clearTask()
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("language.imageSaver.clearHistory")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "task-tab-1" },
          [
            _c(
              "el-tabs",
              {
                ref: "videoTaskListTab",
                attrs: { id: "videoTaskListTab" },
                model: {
                  value: _vm.activeTab,
                  callback: function($$v) {
                    _vm.activeTab = $$v
                  },
                  expression: "activeTab"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("language.imageSaver.all"),
                      name: _vm.tabs[0]
                    }
                  },
                  [
                    _vm.isInit && _vm.isLoading
                      ? _c("div", { staticClass: "image_saver_task_not_init" })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isInit && _vm.allList.length > 0
                      ? _c(
                          "div",
                          { staticClass: "video-task-items" },
                          _vm._l(_vm.allList, function(task) {
                            return _c(
                              "div",
                              { key: task.id, staticClass: "video-task-item" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "item-cover" },
                                  [
                                    task.category == "Audio"
                                      ? _c("div", {
                                          staticClass:
                                            "task-audio-thumbnai-mask"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "el-image",
                                      {
                                        attrs: {
                                          src: task.thumbnailUrl,
                                          fit: "contain"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "image-slot",
                                            attrs: { slot: "error" },
                                            slot: "error"
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "picture-outline"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "item-content" }, [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "ellipsis",
                                          rawName: "v-ellipsis",
                                          value: 2,
                                          expression: "2"
                                        }
                                      ],
                                      staticClass: "item-content-title",
                                      on: {
                                        click: function($event) {
                                          return _vm.jumpByUrl(task.url)
                                        }
                                      }
                                    },
                                    [
                                      task.category == "thumbnail"
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                "[" +
                                                  _vm.$t(
                                                    "language.imageSaver.thumbnail"
                                                  ) +
                                                  "]"
                                              )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(task.fullTitle) +
                                          "\n                                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  task.category != "thumbnail"
                                    ? _c(
                                        "div",
                                        { staticClass: "item-content-attr" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c("div", {
                                                staticClass: "file-type",
                                                class: _vm.matchfileType(
                                                  task.category
                                                )
                                              }),
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.toUpperCase(task.ext)
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.getQualityTxt(task.resolution)
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getQualityTxt(
                                                      task.resolution
                                                    )
                                                  )
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.getQualityTxt(task.resolution) &&
                                          _vm.getAbtTxt(task.abr)
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.imageSaver." +
                                                        _vm.getAbtTxt(task.abr)
                                                    )
                                                  )
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          task.duration
                                            ? _c("span", [
                                                _vm._v(_vm._s(task.duration))
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          task.fileSize
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatByte")(
                                                      task.fileSize
                                                    )
                                                  )
                                                )
                                              ])
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "item-status" }, [
                                  task.status == "Running"
                                    ? _c(
                                        "div",
                                        { staticClass: "item-progress" },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c("el-progress", {
                                                attrs: {
                                                  percentage: task.progress,
                                                  color: "#C1CBE3",
                                                  "show-text": false
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "item-progress-text"
                                                },
                                                [
                                                  task.speed
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatByteSpeed"
                                                            )(task.speed)
                                                          )
                                                        )
                                                      ])
                                                    : _c("span", [
                                                        task.progress &&
                                                        task.progress > 0
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "language.imageSaver.generat"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          : _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "language.imageSaver.taskQueue"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                      ]),
                                                  _vm._v(" "),
                                                  task.progress
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            task.progress + "%"
                                                          )
                                                        )
                                                      ])
                                                    : _c("span", [_vm._v("0%")])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _c("div", { staticClass: "item-state" }, [
                                        task.status == "Fail" && task.notEnough
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "item-state-item"
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../assets/images/imageSaver/widthWarning.svg")
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      color: "#E09D00"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "language.popup.upgradeAccountPopup.insufficientTraffic"
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        task.status == "Fail" && !task.notEnough
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "item-state-item"
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../assets/images/imageSaver/widthError.svg")
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      color: "#F54958"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "language.common.failure"
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        task.status == "Done"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "item-state-item"
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../assets/images/imageSaver/widthSuccess.svg")
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      color: "#30A734"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "language.common.success"
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "item-btns" }, [
                                  task.status == "Running"
                                    ? _c("div", { staticClass: "item-btn" }, [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "cancel-button",
                                            on: {
                                              click: function($event) {
                                                return _vm.cancelTask(task)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("language.common.cancel")
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  task.status == "Fail"
                                    ? _c("div", { staticClass: "item-btn" }, [
                                        _c("div", {
                                          staticClass: "retry",
                                          on: {
                                            click: function($event) {
                                              return _vm.retryTask(task)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm.userTrafficIsNoEnough()
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "upgrade-btn",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.switchToPay()
                                                  }
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../assets/images/imageSaver/widthUpgrade.svg")
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "language.rightTopBanner.upgrade"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    : _vm._e()
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isInit && !_vm.allList.length
                      ? _c("div", { staticClass: "video_task_no" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/images/imageSaver/finishedNoTask.png")
                            }
                          }),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(_vm._s(_vm.$t("language.imageSaver.noTask")))
                          ])
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("language.imageSaver.finished"),
                      name: _vm.tabs[1]
                    }
                  },
                  [
                    _vm.isInit && _vm.isLoading
                      ? _c("div", { staticClass: "image_saver_task_not_init" })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isInit && _vm.finishedList.length > 0
                      ? _c(
                          "div",
                          { staticClass: "video-task-items" },
                          _vm._l(_vm.finishedList, function(task) {
                            return _c(
                              "div",
                              { key: task.id, staticClass: "video-task-item" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "item-cover" },
                                  [
                                    task.category == "Audio"
                                      ? _c("div", {
                                          staticClass:
                                            "task-audio-thumbnai-mask"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "el-image",
                                      {
                                        attrs: {
                                          src: task.thumbnailUrl,
                                          fit: "contain"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "image-slot",
                                            attrs: { slot: "error" },
                                            slot: "error"
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "picture-outline"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "item-content" }, [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "ellipsis",
                                          rawName: "v-ellipsis",
                                          value: 2,
                                          expression: "2"
                                        }
                                      ],
                                      staticClass: "item-content-title",
                                      on: {
                                        click: function($event) {
                                          return _vm.jumpByUrl(task.url)
                                        }
                                      }
                                    },
                                    [
                                      task.category == "thumbnail"
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                "[" +
                                                  _vm.$t(
                                                    "language.imageSaver.thumbnail"
                                                  ) +
                                                  "]"
                                              )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(task.fullTitle) +
                                          "\n                                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  task.category != "thumbnail"
                                    ? _c(
                                        "div",
                                        { staticClass: "item-content-attr" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c("div", {
                                                staticClass: "file-type",
                                                class: _vm.matchfileType(
                                                  task.category
                                                )
                                              }),
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.toUpperCase(task.ext)
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.getQualityTxt(task.resolution)
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getQualityTxt(
                                                      task.resolution
                                                    )
                                                  )
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.getQualityTxt(task.resolution) &&
                                          _vm.getAbtTxt(task.abr)
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.imageSaver." +
                                                        _vm.getAbtTxt(task.abr)
                                                    )
                                                  )
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          task.duration
                                            ? _c("span", [
                                                _vm._v(_vm._s(task.duration))
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          task.fileSize
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatByte")(
                                                      task.fileSize
                                                    )
                                                  )
                                                )
                                              ])
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "item-status" }, [
                                  _c("div", { staticClass: "item-state" }, [
                                    task.status == "Fail"
                                      ? _c(
                                          "div",
                                          { staticClass: "item-state-item" },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: require("../../assets/images/imageSaver/widthError.svg")
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  color: "#F54958"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "language.common.failure"
                                                      )
                                                    ) +
                                                    "\n                                        "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    task.status == "Done"
                                      ? _c(
                                          "div",
                                          { staticClass: "item-state-item" },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: require("../../assets/images/imageSaver/widthSuccess.svg")
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  color: "#30A734"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "language.common.success"
                                                      )
                                                    ) +
                                                    "\n                                        "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "item-btns" }, [
                                  task.status == "Fail"
                                    ? _c("div", { staticClass: "item-btn" }, [
                                        _c("div", {
                                          staticClass: "retry",
                                          on: {
                                            click: function($event) {
                                              return _vm.retryTask(task)
                                            }
                                          }
                                        })
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  task.status && task.status != "Fail"
                                    ? _c("div", { staticClass: "item-btn" }, [
                                        _c("div", {
                                          staticClass: "view",
                                          on: {
                                            click: function($event) {
                                              return _vm.viewTask(task)
                                            }
                                          }
                                        })
                                      ])
                                    : _vm._e()
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isInit && !_vm.finishedList.length
                      ? _c("div", { staticClass: "video_task_no" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/images/imageSaver/finishedNoTask.png")
                            }
                          }),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(_vm._s(_vm.$t("language.imageSaver.noTask")))
                          ])
                        ])
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("upgradeVipDialog", { ref: "upgradeVipDialog" }),
      _vm._v(" "),
      _c("upgradeNewDialog", { ref: "upgradeNewDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51f2b8d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51f2b8d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/video_saver_list.vue
// module id = null
// module chunks = 